import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { UserInfoGuard } from 'src/app/core/guards/user-info.guard';
import { EventMarketplaceComponent } from './event-marketplace/event-marketplace.component';
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { MerchMarketComponent } from './merch-market/merch-market.component';
import { OverviewProductComponent } from './overview-product/overview-product.component';
import { ProductMarketplaceComponent } from './product-marketplace/product-marketplace.component';
import { ProductShoppingcartComponent } from './product-shoppingcart/product-shoppingcart.component';
import { ShippingProductComponent } from './shipping-product/shipping-product.component';
import { CommunitiesComponent } from '../communities/communities.component';


const routes: Routes = [
  {
    path: "",
    component: MarketplaceComponent,   //change this component name to UserHeader
    children: [
      {
        path: "market",
        component: MerchMarketComponent,
      },
      {
        path: "event",
        component: EventMarketplaceComponent,
      },
      
      {
        path: "product-marketplace/:collection_id",
        component: ProductMarketplaceComponent,
      },
      {
        path: "overviewProduct/:product_id/:collection_id",
        component: OverviewProductComponent,
      },
      {
        path: "product-cart/:cart_id",
        component: ProductShoppingcartComponent,
        canActivate: [AuthGuard] 
      },
      {
        path: "product-shipping/:cart_id",
        component: ShippingProductComponent,
        canActivate: [UserInfoGuard] 
      },
           
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MercheMarketplaceRoutingModule { }
